import { FilePath } from '../file-path';
import { IAttribute, IModel } from '../../base/annotation';
import { Metamodel } from '../../base/model';
import { Named } from '../../base/named';
import { isLogicAppExpression } from '../../../shared/utils/expression.util';

export interface ILocationPath {
    container?: string;
    folderPath?: string;
    fileName: string;
}

type PathKey = 'folderPath' | 'fileName' | 'container';

@Metamodel.model({
    abstract: true,
    referable: false
})
export abstract class Location extends Named {
    public static readonly MODEL: IModel;

    public abstract setLocation(path: FilePath): void;
    public abstract setParameterizedLocation(path: ILocationPath): void;
    public abstract getLocation(): FilePath;
    public abstract getParameterizedLocation(): ILocationPath;
    public abstract getFolderPath(): string;
    /**
     * @param fileNameParameterAsFile If the fileName is set to parameter, it will also be treated as file.
     */
    public abstract isFolder(fileNameParameterAsFile?: boolean): boolean;
    /**
     * Specify whether any location property is parameterized
     */
    public abstract isLocationParameterized(): boolean;

    protected setPathPropertyValue(key: PathKey, attribute: IAttribute, path: ILocationPath): void {
        if (isLogicAppExpression(path[key])) {
            attribute.setTemplateValue(this, path[key]);
        } else {
            attribute.setValue(this, path[key]);
        }
    }
}
